import fp from 'lodash/fp';
import { createSelector } from 'reselect';

export const getClient = state => state.client;

export const getClientColumnsByName = createSelector(
  getClient,
  fp.get('columnsByName')
);

export const getClientActiveColumns = createSelector(
  getClientColumnsByName,
  fp.reduce(
    (all, each) => (each.status ? fp.set(each.name, each, all) : all),
    {}
  )
);

export const getClientFormFields = createSelector(
  getClientActiveColumns,
  fp.omit([
    'id',
    'system_id',
    'snap_id',
    'profilePicture',
    'lat',
    'lng',
    'noMatch',
    'addrUpdated',
    'saveCount',
    'visit_exception',
    'visitor_type',
    'dobSet',
    'othersHousehold',
    'updated_at',
    'created_at'
  ])
);

export const getPrimaryFields = createSelector(
  getClientActiveColumns,
  fp.pick(['firstname', 'middlename', 'lastname', 'dob', 'gender', 'race'])
);

export const getHouseholdFields = createSelector(
  (_, isAgeBreakdown) => isAgeBreakdown,
  getClientActiveColumns,
  (includeAgeFields, columns) => ({
    ...fp.pick(
      ['blackball', 'isMember', 'barcode', 'household_total'],
      columns
    ),
    ...(includeAgeFields
      ? fp.pickBy(({ name }) => name.substr(0, 3) === 'age', columns)
      : {}),
    ...fp.pick(
      [
        'location_id',
        'homeless',
        'street_address',
        'apartment',
        'city',
        'state',
        'zipcode',
        'county',
        'phone',
        'workphone',
        'cellphone',
        'email',
        'mailing_address',
        'mailing_apartment',
        'mailing_city',
        'mailing_state',
        'mailing_zipcode',
        'language',
        'education',
        'educationLast',
        'employer',
        'driverLicence',
        'driverLicenceState',
        'marital_status',
        'spouse',
        'spouseDriverLicence',
        'spouseDriverLicenceState',
        'spouseEmployer',
        'contactForHelp',
        'contactForHelpWhy',
        'reason'
      ],
      columns
    )
  })
);

export const getCustomFields = createSelector(
  getClientActiveColumns,
  fp.pickBy(({ name }) => name.substr(0, 3) === 'cf_')
);

export const getAgeFields = createSelector(
  getClientActiveColumns,
  fp.pickBy(({ name }) => name.substr(0, 3) === 'age')
);

export const getStaticCustomFields = createSelector(
  getClientActiveColumns,
  fp.pickBy(({ name }) => name.substr(0, 6) === 'custom')
);

export const getIncomeAndExpenseFields = createSelector(
  getClientActiveColumns,
  fp.pickBy(
    ({ name }) =>
      name.substr(0, 6) === 'income' ||
      name.substr(0, 7) === 'expense' ||
      name.substr(0, 8) === 'netTotal'
  )
);

export const getClientColumnForName = createSelector(
  (_, name) => name,
  getClientColumnsByName,
  fp.get
);

export const getIsFetchingClientColumns = createSelector(
  getClient,
  fp.get('fetchingColumns')
);

export const getIsFetchedClientColumns = createSelector(
  getClient,
  fp.get('fetchedColumns')
);

export const getFetchingClientColumnsError = createSelector(
  getClient,
  fp.get('fetchingColumnsError')
);

export const getClientColumns = createSelector(
  getClientColumnsByName,
  fp.values
);

export const getHouseholdTotalLabel = createSelector(
  getClientColumnsByName,
  fp.getOr('Total Individuals', 'household_total.label')
);
